import { t } from '../i18n';
import { TAP_TARGET, el, replaceChildren } from '../layout/dom';
import { registerScreen } from '../layout/routes';
import { createSlotIcon } from '../ui/icon-registry';

function renderCheckoutThanks(root: HTMLElement): () => void {
  const main = el('main', {
    id: 'main',
    class: 'mx-auto flex min-h-[60vh] w-full max-w-3xl flex-col items-center justify-center gap-6 px-4 py-16 text-center',
  }, [
    el('div', {
      class: 'flex h-16 w-16 items-center justify-center rounded-full bg-success/20',
      'aria-hidden': 'true',
    }, [createSlotIcon(document, 'status-success', { size: 48 })]),
    el('h1', {
      class: 'font-heading text-2xl text-gold',
      text: t('shop.checkout_thanks.title'),
    }),
    el('p', {
      class: 'max-w-md text-text-dim',
      text: t('shop.checkout_thanks.body'),
    }),
    el('a', {
      class: `${TAP_TARGET} mt-4 justify-center rounded px-6 font-bold bg-gold-bright text-ink hover:bg-sun no-underline`,
      href: '/shop',
      text: t('shop.checkout_thanks.back'),
    }),
  ]);

  replaceChildren(root, main);
  return () => replaceChildren(root);
}

registerScreen('/shop/thanks', renderCheckoutThanks);
